import React, { Component } from "react";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import MUIDataTable from "mui-datatables-bitozen";
import LoadingBar from "react-top-loading-bar";
import PopUp from "../../../pages/PopUpAlert";
import API from "../../../../Services/Api";
import { checkResponseError } from "../../../../Services/Utils";
import { connect } from "react-redux";
import * as R from "ramda";
import { Redirect } from "react-router-dom";
import AuthAction from "../../../../Redux/AuthRedux";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import SimpleDate from "../../../../modules/SimpleDate";
import M from "moment";

import DDLCompany from "../../../../modules/commons/DDLCompany";
import SimpleInput from "../../../../modules/SimpleInput";

import Button from "../../../../modules/commons/Button";
import moment from "moment";
import SimpleSearch from "../../../../modules/SimpleSearch";
import SimpleInputRow from "../../../../modules/SimpleInputRow";
import FormMovement from "./formMovement";
import FormEditSupp from "./formEditSupp";
import FormScanStock from "./formScanStock";
import FormApprove from "./formApprove";
import FormFinalized from "./formFinalized";
const UtilsButtonLogin = require("../../../../Services/UtilsButtonLogin");

const ct = require("../../../../modules/custom/customTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());
const options = ct.customOptions6();

class claimC3 extends Component {
  constructor() {
    super();
    this.state = {
      rawData: [],
      // dataTable:[],
      dataTable: [
          [
            "1",
            "SJXXXXX1",
            "LKXXXXX1",
            "23-02-2023",
            "Gear",
            "KC72428471",
            "Buana",
            "Rp. 200.000",
            "Cacat",
            "Process"
          ],
          [
            "2",
            "SJXXXXX2",
            "LKXXXXX2",
            "15-03-2023",
            "Chain",
            "KC72428472",
            "Satria",
            "Rp. 300.000",
            "Rusak",
            "New"
          ],
          [
            "3",
            "SJXXXXX3",
            "LKXXXXX3",
            "28-04-2023",
            "Belt",
            "KC72428473",
            "Vario",
            "Rp. 250.000",
            "Cacat",
            "Received"
          ],
          [
            "4",
            "SJXXXXX4",
            "LKXXXXX4",
            "12-05-2023",
            "Gear",
            "KC72428474",
            "Beat",
            "Rp. 220.000",
            "Rusak",
            "Process"
          ],
          [
            "5",
            "SJXXXXX5",
            "LKXXXXX5",
            "25-06-2023",
            "Chain",
            "KC72428475",
            "Scoopy",
            "Rp. 280.000",
            "Cacat",
            "New"
          ],
          [
            "6",
            "SJXXXXX6",
            "LKXXXXX6",
            "10-07-2023",
            "Belt",
            "KC72428476",
            "Vario",
            "Rp. 230.000",
            "Rusak",
            "Received"
          ],
          [
            "7",
            "SJXXXXX7",
            "LKXXXXX7",
            "22-08-2023",
            "Gear",
            "KC72428477",
            "Buana",
            "Rp. 210.000",
            "Cacat",
            "Process"
          ],
          [
            "8",
            "SJXXXXX8",
            "LKXXXXX8",
            "05-09-2023",
            "Chain",
            "KC72428478",
            "Satria",
            "Rp. 290.000",
            "Rusak",
            "New"
          ],
          [
            "9",
            "SJXXXXX9",
            "LKXXXXX9",
            "19-10-2023",
            "Belt",
            "KC72428479",
            "Vario",
            "Rp. 240.000",
            "Cacat",
            "Received"
          ],
          [
            "10",
            "SJXXXXX10",
            "LKXXXXX10",
            "03-11-2023",
            "Gear",
            "KC724284710",
            "Beat",
            "Rp. 260.000",
            "Rusak",
            "Process"
          ]
      ],
      selectedIndex: [],
      createVisible: false,
      updateVisible: false,
      deletePopUpVisible: false,
      savePopUpVisible: false,
      loadSave: false,
      allowResize: false,
      defaultSize: 0,
      minSize: 0,
      maxSize: 0,
      timeout: 1000 * 100 * 9,
      isTimedOut: false,
      toCount: 0,
      table_limit: 10,
      table_page: 0,
      table_query: "",
      createVisible2: false,
      createVisible3: false,
      createVisible4: false,
      tabIndex: 0,
      checkTab: false,
      data: {},
      dataDto: {},
      buttonAccess: {},
    };
    this.idleTimer = null;
  }

  logout() {
    this.props.authLogout();
    return <Redirect to={{ pathname: "/" }} />;
  }

  onAction() {
    this.setState({ isTimedOut: false });
  }

  onActive() {
    this.setState({ isTimedOut: false });
  }

  onIdle() {
    const isTimedOut = this.state.isTimedOut;
    if (isTimedOut) {
      alert("Your session has timed out. Please log in again");
      this.logout();
    } else {
      this.idleTimer.reset();
      this.setState({ isTimedOut: true });
    }
  }

  componentDidMount() {
    UtilsButtonLogin.buttonAccess("MASTER-022", (response) => {
      // console.log("ORI ", response);
      this.setState(
        {
          buttonAccess: response,
        },
        () => {
          this.getCountPage(this.state.table_page, this.state.table_limit);
        }
      );
    });
  }

  getCountPage = async (page, limit) => {
    let payload = {
      limit: limit,
      offset: page,
      filter: this.state.table_query,
      companyId: this.state.dataDto.companyId,
      companyGroupId: null,
      category: null,
      isActive: null,
      sortBy: this.state.dataDto.sortBy ?? "",
      orderBy: this.state.dataDto.orderBy ?? "",
    };

    let res = await API.create("LOCAL_DELIVERY").getDelivery(payload);
    if (res.ok) {
      if (res.data.data === null) {
        this.setState({ dataTable: [] });
      } else {
        // console.log(JSON.stringify(res.data.data, null, 2));
        let dataTable =
          res.data.data &&
          res.data.data.map((value) => {
            const {
              noid,
              nospk,
              namacustomer,
              tgldelivery,
              unittype,
              warna,
              noka,
              nosin,
              nopickship,
            } = value;
            return [
              noid,
              nospk,
              namacustomer,
              tgldelivery,
              unittype,
              warna,
              noka,
              nosin,
              nopickship,
            ];
          });
        console.log("datatable", dataTable);
        this.setState({
          rawData: res.data.data && res.data.data.listUser,
          dataTable,
          toCount: res.data.data && res.data.data.dataOfRecord,
        });
        this.onFinishFetch();
      }
    }
  };

  handleClearUser = (e) => {
    this.setState(
      {
        table_page: 0,
        toCount: 0,
        data: {},
        dataDto: {},
      },
      () => {
        this.getCountPage(this.state.table_page, this.state.table_limit);
      }
    );
  };

  handleSearch = (eventSearch) => {
    this.setState(
      {
        table_page: 0,
        dataDto: eventSearch ? this.state.data : this.state.dataDto,
      },
      () => {
        this.getCountPage(this.state.table_page, this.state.table_limit);
      }
    );
  };

  isLoad(visible) {
    this.setState({ loadSave: visible });
  }

  checkResponse(res, type) {
    if (res.ok && res.data.status === "S") {
      type === "delete" && this.setState({ deletePopUpVisible: false });
      setTimeout(() => {
        this.openSavePopUp();
      }, 500);
    } else {
      this.isLoad(false);
      checkResponseError(res);
    }
  }

  handleSubmit = async (response) => {
    this.checkResponse(response);
  };

  handleDelete = async () => {
    this.isLoad(true);
    let payload = { ...this.state.rawData[this.state.selectedIndex] };
    payload.action = "DELETE";

    let response = await API.create("MASTERDATA_EKSAD").postSaveUser(payload);
    this.checkResponse(response, "delete");
    this.isLoad(false);
  };

  handlePopUp = () => {
    this.handleSearch();
    this.setState({
      savePopUpVisible: false,
      createVisible: false,
      createVisible2: false,
      createVisible3: false,
      createVisible4: false,
    });
  };

  onChangeDate = (e, name) => {
    this.setState({
      data: {
        ...this.state.data,
        [name]: M(e).format("DD-MM-YYYY"),
      },
    });
  };

  startFetch = () => {
    this.LoadingBar.continousStart();
  };

  onFinishFetch = () => {
    if (typeof this.LoadingBar === "object") this.LoadingBar.complete();
  };

  openCreateForm = () => {
    this.setState({ createVisible: !this.state.createVisible });
  };

  openCreateForm2 = () => {
    this.setState({ createVisible2: !this.state.createVisible2 });
  };

  openCreateForm3 = () => {
    this.setState({ createVisible3: !this.state.createVisible3 });
  };

  openCreateForm4 = () => {
    this.setState({ createVisible4: !this.state.createVisible4 });
  };


  openUpdateForm = () => {
    this.setState({ updateVisible: !this.state.updateVisible });
  };

  openSavePopUp = () => {
    this.setState({
      savePopUpVisible: !this.state.savePopUpVisible,
      loadSave: false,
    });
  };

  openDeletePopup = (index) => {
    this.setState({
      deletePopUpVisible: !this.state.deletePopUpVisible,
      selectedIndex: index,
    });
  };

  columnsUser = [
    { name: "No" },
    { name: "No SJ." },
    { name: "No. LKUAT" },
    { name: "Tgl Claim" },
    { name: "Nama Part" },
    { name: "Part No." },
    { name: "Ekspedisi" },
    { name: "Nilai" },
    { name: "Kerusakan" },
    { name: "Status" },
    {
      name: "Action",
      options: {
        customBodyRender: (val, tableMeta) => {
          return (
            <div style={{ width: "115px" }}>
              <Button
                className="btnAct"
                style={{ marginLeft: 10, backgroundColor: "transparent" }}
                onClick={this.openCreateForm.bind(this)}
                permission=""
              >
                <i
                  className="fa fa-lw fa-pencil-alt"
                  style={{
                    backgroundColor: "transparent",
                    color: "red",
                    fontSize: 20,
                  }}
                />
              </Button>
            </div>
          );
        },
      },
    },
  ];

  onchangeInput = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    this.setState({
      data: {
        ...this.state.data,
        [name]: value,
      },
    });
  };

  opSidePage = (menu, data) => (e) => {
    e.preventDefault();
    let selectedIndex = data;
    this.setState({
      updateVisible: false,
    });

    switch (menu) {
      case "slide-menu-1":
        this.setState({
          updateVisible: true,
          selectedIndex,
          popupType: "update",
        });
        break;
      case "slide-menu-view":
        this.setState({
          updateVisible: true,
          selectedIndex,
          popupType: "view",
        });
        break;
      default:
        break;
    }
  };
  resetTab = (tabIndex) => {
    this.setState({ tabIndex });
    if (tabIndex === 0) {
      this.getCountPage(this.state.table_page, this.state.table_limit);
    }
  };

  render() {
    if (R.isNil(this.props.auth.user))
      return <Redirect to={{ pathname: "/" }} />;
    let { toCount, table_query } = this.state;
    let tableOptions = {
      ...options,
      // serverSide: true,
      filter: false,
      count: toCount,
      searchText: table_query,
      search: false,
      viewColumns: false,
      rowsPerPage: this.state.table_limit,
      page: this.state.table_page,
      onColumnSortChange: (changedColumn, direction) => {
        let order = "desc";
        if (direction === "ascending") {
          order = "asc";
        }

        let columnOrder = "";

        if (changedColumn === "Company") {
          columnOrder = "companyCode";
        }

        if (changedColumn === "Username") {
          columnOrder = "username";
        }

        if (changedColumn === "Email") {
          columnOrder = "email";
        }

        if (changedColumn === "Category") {
          columnOrder = "category";
        }

        if (changedColumn === "Employee Name") {
          columnOrder = "name";
        }

        if (changedColumn === "Status") {
          columnOrder = "status";
        }

        this.columnsUser.map((value, index) => {
          if (changedColumn === value.name && value.name !== "Action") {
            value.options = { sortDirection: order };
          } else {
            value.options = { ...value.options, sortDirection: "none" };
          }
        });
        this.columnsMovement.map((value, index) => {
          if (changedColumn === value.name && value.name !== "Action") {
            value.options = { sortDirection: order };
          } else {
            value.options = { ...value.options, sortDirection: "none" };
          }
        });

        this.setState(
          {
            dataDto: {
              ...this.state.dataDto,
              sortBy: columnOrder,
              orderBy: order,
            },
          },
          () => {
            this.getCountPage(this.state.table_page, this.state.table_limit);
          }
        );
      },
      onTableChange: (action, tableState) => {
        switch (action) {
          case "changePage":
            this.setState({ table_page: tableState.page });
            this.getCountPage(tableState.page, tableState.rowsPerPage);
            break;
          case "changeRowsPerPage":
            this.setState({ table_limit: tableState.rowsPerPage });
            this.getCountPage(tableState.page, tableState.rowsPerPage);
            break;
          case "search":
            let searchText = tableState.searchText ? tableState.searchText : "";
            this.setState({ table_query: searchText }, () => {
              this.handleSearch();
            });
            break;
          default:
            break;
        }
      },
    };
    return (
      <div className="main-slider">
        <div className="padding-tbl-monitoring">
          <LoadingBar onRef={(ref) => (this.LoadingBar = ref)} />
          <Tabs
            selectedIndex={this.state.tabIndex}
            onSelect={(tabIndex) => this.resetTab(tabIndex)}
          >
            <TabList>
              <Tab>Claim C3</Tab>
            </TabList>
            <TabPanel>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Button
                    type="button"
                    style={{ width: "170px" }}
                    className="btn btn-plus background-red margin-left-15px"
                    valueCombo={this.state.data.companyIdSelect}
                    onClick={this.openCreateForm3.bind(this)}
                  >
                    <span>
                      <i
                        className="fa fa-plus"
                        style={{ marginRight: "10px" }}
                      />
                      Tambah Claim
                    </span>
                  </Button>
                </div>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <div
                    style={{
                      display: "flex",
                      marginTop: "5px",
                      marginLeft: "5px",
                      marginRight: "5px",
                    }}
                  >
                    <div
                      style={{
                        width: 200,
                        marginRight: "15px",
                        marginLeft: "15px",
                      }}
                    >
                      <DDLCompany
                        // label={"No SL"}
                        box={"search"}
                        hierarchy={false}
                        onChangeCombo={(value) => {
                          this.setState({
                            data: { ...this.state.data, ...value },
                          });
                        }}
                        valueCombo={this.state.data.companyIdSelect}
                      />
                    </div>

                    <div>
                      <SimpleInput
                        name="Parts"
                        value={this.state.data.Parts}
                        onChange={this.onchangeInput}
                      />
                    </div>
                  </div>

                  <div style={{ marginTop: "8px" }}>
                    <Button
                      type="button"
                      style={{ width: "90px" }}
                      className="btn btn-plus background-red margin-left-15px"
                      valueCombo={this.state.data.companyIdSelect}
                      onClick={this.openCreateForm4.bind(this)}
                    >
                      <span>
                        <i
                          // className="fa fa-filter"
                          style={{ marginRight: "10px" }}
                        />
                        Cari
                      </span>
                    </Button>
                  </div>
                </div>
              </div>
              <div>
                <MuiThemeProvider theme={getMuiTheme()}>
                  <MUIDataTable
                    key={toCount}
                    data={this.state.dataTable}
                    title={"Supplier List"}
                    columns={this.columnsUser}
                    options={tableOptions}
                    // buttonCreate={this.state.buttonAccess.btnAdd}
                    // onCreate={this.openCreateForm.bind(this)}
                  />
                </MuiThemeProvider>
                <div style={{display:"flex", justifyContent:"space-between", padding : 20}}>
                <Button
                  style={{ width: "100", marginTop: 10 }}
                  className="btn btn-back"
                  type="button"
                  >
                  <span>Export</span>
                </Button>
                <Button
                  style={{width: "100", marginTop: 10 }}
                  className="btn btn-back"
                  type="button"
                  >
                  <span>Print</span>
                </Button>
                  </div>
              </div>
            </TabPanel>
          </Tabs>
          <div
            style={{ float: "right", marginRight: "1vw" }}
            className="padding-top-30px padding-bottom-20px"
          >
            {/* <button
              style={{ marginLeft: "15px" }}
              className="btn btn-back"
              type="button"ff
            >
              <span>BACK</span>
            </button>
            <button
              style={{ marginLeft: "15px" }}
              className="btn btn-back"
              type="button"
              onClick={this.openCreateForm.bind(this)}
            >
              <span>PROCCESS</span>
            </button> */}
          </div>
        </div>

        <div>
          {this.state.createVisible && (
            <FormEditSupp
              type={"create"}
              loadSave={this.state.loadSave}
              user={this.props.auth.user}
              onClickClose={this.openCreateForm.bind(this)}
              onClickSave={this.handleSubmit.bind(this)}
            />
          )}

          {/* {this.state.updateVisible && (
            <FormEditStock
              type={this.state.popupType === "update" ? "edit" : "view"}
              data={this.state.rawData[this.state.selectedIndex]}
              loadSave={this.state.loadSave}
              user={this.props.auth.user}
              onClickClose={this.openUpdateForm.bind(this)}
              onClickSave={this.handleSubmit.bind(this)}
            />
          )} */}

          {this.state.createVisible2 && (
            <FormScanStock
              type={"create"}
              loadSave={this.state.loadSave}
              user={this.props.auth.user}
              onClickClose={this.openCreateForm2.bind(this)}
              onClickSave={this.handleSubmit.bind(this)}
            />
          )}

          {/* {this.state.updateVisible2 && (
            <FormScanStock
              type={this.state.popupType === "update" ? "edit" : "view"}
              data={this.state.rawData[this.state.selectedIndex]}
              loadSave={this.state.loadSave}
              user={this.props.auth.user}
              onClickClose={this.openUpdateForm.bind(this)}
              onClickSave={this.handleSubmit.bind(this)}
            />
          )} */}

          {this.state.createVisible3 && (
            <FormEditSupp
              type={"create"}
              loadSave={this.state.loadSave}
              user={this.props.auth.user}
              onClickClose={this.openCreateForm3.bind(this)}
              onClickSave={this.handleSubmit.bind(this)}
            />
          )}

          {this.state.createVisible4 && (
            <FormApprove
              type={"create"}
              loadSave={this.state.loadSave}
              user={this.props.auth.user}
              onClickClose={this.openCreateForm4.bind(this)}
              onClickSave={this.handleSubmit.bind(this)}
            />
          )}

          {this.state.savePopUpVisible && (
            <PopUp
              type={"save"}
              class={"app-popup app-popup-show"}
              onClick={this.handlePopUp.bind(this)}
            />
          )}

          {this.state.deletePopUpVisible && (
            <PopUp
              type={"delete"}
              class={"app-popup app-popup-show"}
              onClickDelete={this.handleDelete}
              onClick={this.openDeletePopup}
              isLoading={this.state.loadSave}
            />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    h1Module: state.h1Module,
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    authLogout: () => dispatch(AuthAction.authLogout()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(claimC3);
